import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { Button } from "rhombus-react";

import { buildSharableLink, buildBulkSharableLink } from "widgets/modals/creatives/preview/sharing/utils";
import useCopyPlaintext from "hooks/useCopyPlaintext";


export default function CopyLinksButton(props){
	const { useVersionLinks } = props;
	const {
		sharableLinks = [],
		isLoadingSharableLinks,
		hasErrorLoadingSharableLinks,
	} = useSelector(state => state.creativePreviews);

	const [clipContainerRef, copyPlaintextToClipboard] = useCopyPlaintext();
	const [textToCopy, setTextToCopy] = useState('');
	const [isCopying, setIsCopying] = useState(false);
	const [hasCopied, setHasCopied] = useState(false);
	const [copySuccess, setCopySuccess] = useState(false);

	useEffect(() => {
		const clipboardText = sharableLinks.map((link) => {
			const adType = link.creative?.adType;
			const url = adType ? buildSharableLink(link.publicId, link.creative, useVersionLinks) : buildBulkSharableLink(link.publicId, sharableLinks, useVersionLinks);
			return `${link?.previewName}\t${url}`;
		}).join('\n');

		setHasCopied(false);
		setTextToCopy(clipboardText);
	}, [sharableLinks, useVersionLinks]);

	const copyLinksToClipboard = (e) => {
		setIsCopying(true);
		let success = copyPlaintextToClipboard(textToCopy);
		setIsCopying(false);
		if (success) {
			setHasCopied(true);
			setCopySuccess(true);
		} else {
			setHasCopied(true);
			setCopySuccess(false);
		}
	};

	let theme = "blue";
	let buttonText = "Copy To Clipboard";
	if (hasCopied) {
		if (copySuccess) {
			theme = "green";
			buttonText = "Copied to Clipboard";
		} else {
			theme = "red";
			buttonText = "Copy Failed";
		}
	}

	return (
		<span ref={clipContainerRef}>
			<Button
				theme = {theme}
				onClick = {copyLinksToClipboard}
				disabled = {isLoadingSharableLinks || hasErrorLoadingSharableLinks || isCopying}
			>
				{buttonText}
			</Button>
		</span>
	);
}

CopyLinksButton.displayName = "CopyLinksButton";
CopyLinksButton.defaultProps = {
	useVersionLinks: false,
};
